import { lazy } from 'react';

/**
 * Lazy React modules mounted at `/games/:slug`. Keep in sync with `hubGames` catalog entries.
 */
export const gameComponents = {
  'paper-fly': lazy(() =>
    import(/* webpackChunkName: "game-paper-fly" */ '@stans-world/game-paper-fly/client')
  ),
};

export const registeredGameSlugs = Object.keys(gameComponents);
